// client/src/features/communication/ChannelWizard.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getToken } from '../../utils/auth';

const channelTypes = [
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'chat', label: 'Chat' },
    { value: 'video', label: 'Video' },
    { value: 'social', label: 'Social' },
    { value: 'custom', label: 'Custom' },
];

export default function ChannelWizard() {
    const { t } = useTranslation();
    const [step, setStep] = useState(1);
    const [config, setConfig] = useState({
        type: 'email',
        name: '',
        participants: [],
        settings: {},
    });
    const [message, setMessage] = useState('');

    const handleNext = () => setStep(step + 1);
    const handleBack = () => setStep(step - 1);

    const handleSubmit = async () => {
        try {
            const token = getToken();
            const res = await axios.post(
                '/api/messaging/communication/channel',
                config,
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
            );
            setMessage(t('channel_created') + ': ' + res.data.channel.id);
        } catch (err) {
            setMessage(err.response?.data?.message || err.message);
        }
    };

    return (
        <div className="max-w-lg mx-auto p-4" aria-live="polite">
            <h2 className="text-xl font-bold mb-4">{t('create_communication_channel')}</h2>
            {step === 1 && (
                <div>
                    <label>{t('channel_type')}</label>
                    <select
                        value={config.type}
                        onChange={e => setConfig({ ...config, type: e.target.value })}
                        className="border rounded w-full p-2"
                    >
                        {channelTypes.map(ct => (
                            <option key={ct.value} value={ct.value}>{t(ct.label)}</option>
                        ))}
                    </select>
                    <button onClick={handleNext} className="mt-4 btn-primary">{t('next')}</button>
                </div>
            )}
            {step === 2 && (
                <div>
                    <label>{t('channel_name')}</label>
                    <input
                        type="text"
                        value={config.name}
                        onChange={e => setConfig({ ...config, name: e.target.value })}
                        className="border rounded w-full p-2"
                    />
                    <button onClick={handleBack} className="mr-2 btn-secondary">{t('back')}</button>
                    <button onClick={handleNext} className="btn-primary">{t('next')}</button>
                </div>
            )}
            {step === 3 && (
                <div>
                    <label>{t('participants')}</label>
                    <input
                        type="text"
                        placeholder={t('comma_separated_user_ids')}
                        onChange={e =>
                            setConfig({
                                ...config,
                                participants: e.target.value.split(',').map(id => ({ id: id.trim(), role: 'member' })),
                            })
                        }
                        className="border rounded w-full p-2"
                    />
                    <button onClick={handleBack} className="mr-2 btn-secondary">{t('back')}</button>
                    <button onClick={handleSubmit} className="btn-primary">{t('create')}</button>
                </div>
            )}
            {message && <p className="mt-4">{message}</p>}
        </div>
    );
}
